import { convertQueryStringsObj } from './utils';
import { ConfigArguments, Language, DefaultDataPerVertical, DefaultDataPerDevice } from './types';

const sportsRegSources = ['SX', 'SM', 'ST'];
const openBetLanguages = {
  'de-de': 'de-de',
  'el-gr': 'el',
  'en-gb': 'en-gb',
  'es-es': 'es-es',
  'fr-fr': 'fr-fr',
  'it-it': 'it',
  'ja-jp': 'ja',
  'pl-pl': 'pl',
  'ru-ru': 'ru',
  'sv-se': 'sv',
  'zh-cn': 'zh-cn',
  'zh-hk': 'zh-hk',
};

const getEnvPostfix = (env?: string): string => (!env || env === 'prod' ? '' : `-${env}`);
const getOpenBetLanguage = (language: Language): string => openBetLanguages[language] || language;
const getDepositHtmlPageName = (userFlow?: string): string =>
  userFlow === 'registration' ? 'post_register' : 'deposit';

interface GetDefaultActionDataType {
  config: ConfigArguments;
  data?: string | DefaultDataPerVertical | DefaultDataPerDevice;
  context?: { [key: string]: any }; // tslint:disable-line: no-any
}

export const getDefaultActionData = ({ data, config, context }: GetDefaultActionDataType): string | undefined => {
  if (typeof data !== 'string' && typeof data !== 'object') {
    return undefined;
  }

  const { env, language, regSource, isMobile } = config;
  const { userFlow = '', params: extraQryStrs = {} } = context || {};
  const convertedQryStrs = convertQueryStringsObj(extraQryStrs);

  let result;
  if (typeof data === 'object') {
    const vertical = sportsRegSources.indexOf(regSource) !== -1 ? 'sports' : 'gaming';
    const device = isMobile ? 'mobile' : 'desktop';

    // @ts-ignore
    result = data[device] || data[vertical][device];
  } else {
    result = data;
  }

  return result
    .replace('{lang}', language)
    .replace('{regSource}', regSource)
    .replace('{env}', getEnvPostfix(env))
    .replace('{obLang}', getOpenBetLanguage(language))
    .replace('{extraQryStrs}', convertedQryStrs ? `&${convertedQryStrs}` : '')
    .replace('{depositHtmlPage}', getDepositHtmlPageName(userFlow));
};
